import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import projectInfo from "../../../Information/ProjectInfo/ProjectInfo";
import "./HomeProject.css";
import HomeProjectCard from "./HomeProjectCard/HomeProjectCard";

const HomeProject = () => {
  const homeProject = projectInfo.slice(0, 3);
  return (
    <section className="home-project container my-3">
      <div className="d-flex flex-column align-items-center">
        <h1 className="text-primary">Projects</h1>
        <div className="underLine"></div>
      </div>
      <div className="row my-3">
        {homeProject.map((project) => (
          <HomeProjectCard key={project.id} project={project}></HomeProjectCard>
        ))}
      </div>
      <Link to="/project">
        <Button
          className="form-control my-2 btn"
          style={{ backgroundColor: "#FA58D0" }}
        >
          More Projects
        </Button>
      </Link>
    </section>
  );
};

export default HomeProject;
